module.exports = __webpack_public_path__ + "static/media/B.c81895dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/B.jpg
// module id = 70
// module chunks = 0